import { useMediaQuery } from 'react-responsive';

export const BREAKPOINTS = {
    mobile: 600, // < 600  -> mobile
    tablet: 1125, // 600-1124 -> tablet
};

export function useResponsive() {
    const isMobile = useMediaQuery({ maxWidth: BREAKPOINTS.mobile - 1 });
    const isTablet = useMediaQuery({
        minWidth: BREAKPOINTS.mobile,
        maxWidth: BREAKPOINTS.tablet - 1,
    });
    const isDesktop = useMediaQuery({ minWidth: BREAKPOINTS.tablet });

    return { isMobile, isTablet, isDesktop };
}
